// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__VEbf6","tab":"Tabs_tab__Tgu4R","tabActive":"Tabs_tabActive__2lzOy"};